module.exports = __webpack_public_path__ + "img/discord.fdbd0cb6.png";